<template>
<div style='height:100%;'>
    <div class="wrapper" ref='wrapper' :style="{ 'background': 'url('+ require('../../assets/image/'+ backgroundImage +'.jpg') +') no-repeat center top', backgroundSize: '2500px auto'}">
        <div class="texture"></div>
        <Topnav class="top_nav" />
        <div class="container">
            <Slidetxt class='slide-txt' v-if="ifSlide"/>
            <div class="flex clearfix" :style="{ width: flexWidth + 'px' }">
                <div class="left_nav" v-if="ifLeftnav">
                    <Leftnav ref='leftNav' />
                </div>
                <!-- <keep-alive> -->
                    <router-view :key='key' class="router_wrapper" :style="{width: ifLeftnav ? '879px' : '100%', 'position': 'relative'}"></router-view>
                    
                <!-- </keep-alive> -->
            </div>
        </div>
        <Foot class="foot" />
    </div>
    <PopOver class="pop" ref="pop" :show="popShow">
        <Order ref="myOrder" @pay="pay" @program-apply="gotoProgramApply" v-show='orderShow' />
        <ProgramApply ref="programApply" @pay="pay" @back='backToOrder' v-show="programApplyShow"/>
        <Payment :show='payShow' @back='backToOrder'/>
    </PopOver>
        <WT8BookInfo v-if="$store.state.isbook"/>

</div>
    
</template>

<script>
    // @ is an alias to /src
    import Topnav from '@/components/Topnav.vue'
    import Leftnav from '@/components/Leftnav.vue'
    import Foot from '@/components/Foot.vue'
    import config from "@/assets/js/config.js"
    import Order from '@/components/Order.vue'
    import Payment from '@/components/Payment.vue'
    import ProgramApply from '../../components/ProgramApply.vue'
    import WT8BookInfo from '../../components/WT8BookInfo.vue';
    export default {
        name: 'Layout',
        inject: ['appOverFlow'],
        props: {
            call: {
                type: Function,
                default: function (x) {
                    switch (x) {
                        case 0:
                            this.$route.path !== '/' && this.$router.push('/')
                            break
                        case 2:
                            window.open('https://u.wenhua.com.cn')
                            break
                        case 3:
                            this.$route.path !== '/question' && this.$router.push('/question')
                            break
                        case 4:
                            this.$route.path !== '/risk' && this.$router.push('/risk')
                            break
                    }
                }
            }
        },
        provide() {
            let self = this
            return {
                navCall(x) {
                    self.call(x)
                },
                navActTxt () {
                    return self.$refs.leftNav ? self.$refs.leftNav.navTxt : ''
                },
                popOverShow (x) {
                    self.popShow = x
                },
                paymentShow (x) {
                    self.payShow = x
                },
                orderShow (x) {
                    self.orderShow = x
                },
                programApplyShow (x) {
                    self.programApplyShow = x
                    self.$refs.programApply.clear()
                },
                initOrder () {
                    self.$refs.myOrder.DataIinitialization(self.$store.state.orderInfo);
                },
                setSeatInstance (inst) {
                    self.seatInstance = inst
                },
                seatInstance () {
                    return self.seatInstance
                },
                setAddBuyValidState(fn) {
                    self.clearAddBuyValidState = fn
                },
                clearAddBuyValidState () {
                    return self.clearAddBuyValidState || (()=>{})
                },
                setRenewBuyValidState(fn) {
                    self.clearRenewBuyValidState = fn
                },
                clearRenewBuyValidState () {
                    return self.clearRenewBuyValidState || (()=>{})
                }
            }
        },
        data: ()=>({
            popShow: true,
            orderShow: true,
            payShow: false,
            programApplyShow: false,
            seatInstance: null,
            clearAddBuyValidState: null,
            clearRenewBuyValidState: null,
            backgroundImage: 'body_bg',
            flexWidth: 1270
        }),
        methods: {
            pay(){
                this.popShow = true;
                this.orderShow = false
                this.programApplyShow = false
                this.payShow = true
                this.appOverFlow('hidden')
            },
            backToOrder () {
                this.payShow = false;
                this.programApplyShow = false
                this.orderShow = true
            },
            gotoProgramApply () {
                this.orderShow = false
                this.programApplyShow = true
                this.$nextTick(() => {
                    this.$refs.programApply.clear()
                })
                this.appOverFlow('hidden')
            }
        },
        components: {
            Topnav,
            Foot,
            Leftnav,
            Order,
            Payment,
            ProgramApply,
            WT8BookInfo
        },
        computed: {
            ifLeftnav () {
                var routerName = this.$route.name
                return config.leftNav.find(v=>v==routerName) ? true : false
            },
            ifSlide () {
                // return this.$route.name == 'Home'
                return true
            },
            key() {
                if (this.$route.name == 'Home') return 'Home'
                //防止同一路由跳转不触发生命周期的钩子，给router-view加上key
                return this.$route.name !== undefined? this.$route.name + +new Date(): this.$route + +new Date()
            }
        },
        mounted () {
            //手机版页面方便查看的缩放适配
            if (window.screen.width < this.$refs.wrapper.clientWidth && isMobileBrowser()) {
                this.$refs.wrapper.style.transform = `scale(${window.screen.width/this.$refs.wrapper.clientWidth})`
                window.windowScale = window.screen.width/this.$refs.wrapper.clientWidth
            }
            let orderWidth = this.$refs.myOrder.$el.offsetWidth
            this.popShow = false
            this.orderShow = false

            function isMobileBrowser() {
                // 获取浏览器的 userAgent 信息（设备/浏览器标识）
                const userAgent = navigator.userAgent || navigator.vendor || window.opera;

                // 匹配所有主流手机系统：Android / iPhone / iPod / BlackBerry / Windows Phone
                const mobileRegex = /android|iphone|ipod|blackberry|iemobile|opera mini/i;

                // 返回判断结果
                return mobileRegex.test(userAgent);
            }
            if (window.screen.width < orderWidth && isMobileBrowser()) {
                this.$refs.pop.$el.style.transform = `scale(${window.screen.width/orderWidth})`
                window.orderScale = window.screen.width/orderWidth
            }
            window.addEventListener('resize', () => {
                if (!isMobileBrowser()) return
                if (window.screen.width < this.$refs.wrapper.clientWidth) {
                    this.$refs.wrapper.style.transform = `scale(${window.screen.width/this.$refs.wrapper.clientWidth})`
                }
                if (window.screen.width < orderWidth) {
                    this.$refs.pop.$el.style.transform = `scale(${window.screen.width/orderWidth})`
                }
            })
        },
        watch:{
            "$route": {
                    handler (val) {
                        if (val.name == 'Home') {
                            this.backgroundImage = "body_bg2"
                            this.flexWidth = 1684
                        } else {
                            this.backgroundImage = "body_bg"
                            this.flexWidth = 1270
                        }
                    },
                    immediate: true
                },
            },
        }
</script>

<style scoped>
    .pop {
        transform-origin: right top;
    }
    .left_nav {
        /* flex: 0 360px; */
        /* width: 360px; */
        width: 391px;
        float: left;
    }

    .router_wrapper {
        /* flex: 0 918px; */
        /* width: 918px; */
        float: left;
    }

    .flex {
        /* display: flex; */
        /* width: 1360px; */
        width: 1270px;
        margin: 0 auto;
        padding-top: 20px;
    }

    .wrapper {
        position: absolute;
        top: 0;
        left: 0;
        padding:72px 0 72px 0;
        min-width: 100%;
        min-height: 100%;
        box-sizing: border-box;
        z-index: 2;
        transform-origin: left top;
        overflow: hidden;
    }
    
    /* .wrapper::before {
        content: '';
        position: absolute;
        z-index: 2;
        left: 0;
        width: 100%;
        top: 1440px;
        bottom: 0;
        background: url(../../assets/image/left-back.jpg) repeat-y center;

    } */
    /* .wrapper::after {
        content: '';
        position: absolute;
        z-index: 2;
        right: 0;
        width: 60%;
        top: 1440px;
        bottom: 0;
        background-color: #0065ad;

    } */
    .top_nav {
        position: absolute;
        top: 0;
        height: 72px;
        min-width: 100%;
        background: white;
    }

    .foot {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 72px;
        z-index: 10;
    }
    .container{
        position: relative;
        padding-top: 30px;
        z-index: 6;
    }
    
    .texture {
        width:395px;
        height: 449px;
        position: absolute;
        left: 50%;
        margin-left: 280px;
        bottom: 0;
        z-index: 5;
        background: url(../../assets/image/texture.png) no-repeat center;
    }
</style>